import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './modalToolbar.scss';

/**
 * ModalToolbar Component
 * 
 * Optional toolbar at the top of the modal for displaying headers,
 * titles, or other content. Commonly used for:
 * - Modal titles/headers
 * - Photo gallery navigation
 * - Step indicators
 * - Breadcrumbs
 */

export function ModalToolbar({ children, className }) {
	return (
		<div className={classnames('new-modal-toolbar', className)}>
			<div className='toolbar-content'>
				{children}
			</div>
		</div>
	);
}

ModalToolbar.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string
};

export default ModalToolbar;
